import React from 'react';
import PropTypes from 'prop-types';
import { reducer } from './reducer';

export const DoubleListBoxContext = React.createContext();

export function DoubleListBoxContextProvider({
  pageSize,
  children,
  initialSelectedItems,
}) {
  const [state, dispatch] = React.useReducer(reducer, {
    items: [],
    selectedItems: initialSelectedItems || [],
    search: '',
    selectionSearch: '',
    pageNumber: 1,
    pageSize,
  });
  const context = {
    state,
    dispatch,
  };

  return (
    <DoubleListBoxContext.Provider value={context}>
      {children}
    </DoubleListBoxContext.Provider>
  );
}

export const withDoubleListBoxContext = Component => (props) => {
  const context = React.useContext(DoubleListBoxContext);
  return <Component {...props} context={context} />;
};

DoubleListBoxContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  pageSize: PropTypes.number,
  initialSelectedItems: PropTypes.arrayOf(PropTypes.shape({})),
};

DoubleListBoxContextProvider.defaultProps = {
  pageSize: null, // no pagination if not specified
  initialSelectedItems: null,
};
